import { render, staticRenderFns } from "./VersionUpdateNotification.vue?vue&type=template&id=116a3f95&scoped=true&"
import script from "./VersionUpdateNotification.vue?vue&type=script&lang=js&"
export * from "./VersionUpdateNotification.vue?vue&type=script&lang=js&"
import style0 from "./VersionUpdateNotification.vue?vue&type=style&index=0&id=116a3f95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116a3f95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBanner,VBtn,VIcon})
